var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1076,
    height: 1080,
    viewBox: "0 0 1076 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M1080.07 1079.66V197.351V-1.05237L933.664 17.6209C797.281 58.2823 741.263 99.3891 668.834 197.351C641.66 236.171 536.41 297.744 512.314 372.293C488.217 446.842 540.7 469.156 512.313 511.739C368.681 677.796 3.71053 759.52 195.411 1079.66H1080.07Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M1080.07 707.562L1080.07 1079.66L1.89368 1079.66C-14.0527 928.87 72.7176 833.583 186.558 785.125C352.046 761.331 365.361 685.014 528.767 707.562C636.031 738.173 759.313 726.552 849.419 676.131C916.137 594.491 1080.07 660.415 1080.07 707.562Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M713.449 736.3C583.392 744.761 607.013 994.735 660.231 1079.66H1080.44V528.406C1030.43 574.111 993.038 582.898 912.272 573.215C776.641 633.737 737.942 669.709 713.449 736.3Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.78
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 816.892,
    y1: 216.113,
    x2: 53.9456,
    y2: 1196.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -124.31,
    y1: 659.364,
    x2: 301.896,
    y2: 1356.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 617.655,
    y1: 856.007,
    x2: 1583.1,
    y2: 744.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99B740",
    stopOpacity: 0.59
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSvg);
export default __webpack_public_path__ + "static/media/rightSVG.f1d0f4a4.svg";
export { ForwardRef as ReactComponent };